import React from 'react';
import PropTypes from 'prop-types';
import {cleanHtml} from 'helpers/commonHelper';

const Marquee = ({announcement}) => (
  <div className="bg-accent text-white pt-1 text-nowrap">
    <marquee
      width="100%"
      direction="left"
      dangerouslySetInnerHTML={{__html: cleanHtml(announcement)}}
    />
  </div>
);

Marquee.propTypes = {
  announcement: PropTypes.string.isRequired
};

export default Marquee;
